export default __webpack_public_path__ + "static/media/medbed.a79fc1d3.PNG";